/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_SigningInputs */

const cs_nav_signing = /** @type {(inputs: Nav_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podpisy`)
};

const en_nav_signing = /** @type {(inputs: Nav_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing`)
};

/**
* | output |
* | --- |
* | "Signing" |
*
* @param {Nav_SigningInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_signing = /** @type {((inputs?: Nav_SigningInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_SigningInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_signing(inputs)
	return cs_nav_signing(inputs)
});